import { render, staticRenderFns } from "./InputBox.vue?vue&type=template&id=b90d11b6"
import script from "./InputBox.vue?vue&type=script&lang=ts"
export * from "./InputBox.vue?vue&type=script&lang=ts"
import style0 from "./InputBox.vue?vue&type=style&index=0&id=b90d11b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports